<template>
    <div>
        <Title title="用户协议" :path="formPath"/>

        <div class="abbox">
            <div class="abnav">
                <router-link to="/about">关于我们</router-link>
                <router-link to="/mianze">免责声明</router-link>
                <router-link to="/treaty" class="curr">用户协议</router-link>
                <router-link to="/contact">联系我们</router-link>
            </div>
            <div class="abright">
                <div class="abmain">
<!--                    <div class="title"><span>关于我们</span><em>/About US</em><i></i></div>-->
                    <div class="treaty">

                        <TreatyMini/>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Title from '../public/title'
    import TreatyMini from '../public/treaty_mini'
    export default {
        name: "about",
        components: {
          Title,
            TreatyMini
        },
        data() {
            return {
                formPath: ''
            }
        },
        activated() {
            this.$backTop()
        },
        methods: {
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/my':''
            })
        }
    }
</script>

<style scoped>
</style>
